import { MeansOfTransportType } from '../../sharedComponents/common.types';

import { MeansOfTransport, TransportOrder } from '../transportAssignment.types';
import { TransportOrderBulkUpdateFormState } from './transportOrderBulkUpdateForm.types';
import {
    keepFirstValidationMessage,
    getEmptyValidationResult,
    validateMeansOfTransportLength,
    validateTrailerIdLength,
    validateDeliveryDate,
    validatePickUpDate,
} from '../shared/sharedFormValidations';
import { ValidationResult } from '../../sharedComponents/validationResult.type';

type TransportOrderBulkUpdateValidationResult = {
    confirmedPickUpDate: ValidationResult;
    confirmedDeliveryDate: ValidationResult;
    meansOfTransport: ValidationResult;
    trailer: ValidationResult;
    isButtonDisabled: boolean;
};

export const validateAcrossAssignments = (
    validAssignments: TransportOrder[],
    validateAssignment: (assignment: TransportOrder) => ValidationResult,
) =>
    validAssignments.reduce(
        (validationResult, assignment) => keepFirstValidationMessage(validationResult, validateAssignment(assignment)),
        getEmptyValidationResult(),
    );

export const validateTransportOrderBulkUpdateForm = (
    validAssignments: TransportOrder[],
    formState: TransportOrderBulkUpdateFormState,
): TransportOrderBulkUpdateValidationResult => {
    const meansOfTransport: MeansOfTransport = {
        type: MeansOfTransportType.TRUCK,
        id: formState.truckLicensePlate,
        trailerId: formState.trailerLicensePlate,
    };

    const result = {
        confirmedPickUpDate: validateAcrossAssignments(validAssignments, (assignment) =>
            validatePickUpDate(assignment.loading.requestedPickUpDate, formState.confirmedPickUpDate),
        ),
        confirmedDeliveryDate: validateAcrossAssignments(validAssignments, (assignment) =>
            validateDeliveryDate(
                {
                    orderIssuedAt: assignment.orderIssuedAt,
                    requestedDeliveryDate: assignment.unloading.requestedDeliveryDate,
                },
                formState.confirmedDeliveryDate,
            ),
        ),
        meansOfTransport: validateMeansOfTransportLength(meansOfTransport),
        trailer: validateTrailerIdLength(meansOfTransport),
    };

    return {
        ...result,
        isButtonDisabled: Object.values(result).some((validation) => Boolean(validation.error)),
    };
};
